import { API_VERSION, DATASET, PROJECT_ID, SANITY_API_READ_TOKEN } from "@/env";
import { createClient, SanityClient } from "next-sanity";
import { isPreviewMode } from "./utils";

export const client: SanityClient = createClient({
  projectId: PROJECT_ID,
  dataset: DATASET,
  apiVersion: API_VERSION,
  perspective: isPreviewMode ? "previewDrafts" : "published",
  token: isPreviewMode ? SANITY_API_READ_TOKEN : undefined,
  useCdn: isPreviewMode ? false : true,
  ignoreBrowserTokenWarning: true,
});
